import Scrolllock from 'react-scrolllock';
import { Typo, Dialogue } from '@geberit/gdds';

// styles
import styles from '../detail.module.scss';

// types
import type { ProductLocatorItem } from '../../Sidebar/Sidebar.types';

// components
import { ProductDetail } from './ProductDetail';
import { Lightbox } from 'components/lightbox/lightbox';
import { LightboxHeader } from 'components/lightbox/lightbox-header';

// utils
import { decodingContent } from 'utils/decodingContent';
import { useIsMobile } from 'components/App/SizeProvider';

type ProductLightboxProps = {
  item: ProductLocatorItem;
  onClose: () => void;
  detailLayer?: string;
  isNord?: boolean;
};

export function ProductLightbox({ onClose, ...props }: Readonly<ProductLightboxProps>) {
  const isMobile = useIsMobile();
  const {
    detailLayer,
    item: { name },
    isNord = false,
  } = props;
  const headline = (detailLayer ?? '') || name;

  if (isNord) {
    return (
      <div className={styles.modalWrapper}>
        <Dialogue
          closeDialogue={onClose}
          size={isMobile ? 's' : 'm'}
          type="custom"
          noFooterButton
          widerMobilePadding
          body={
            <div className={styles.nord__lightbox__headline}>
              <Typo className={styles.headline} variant="h3" fontWeight={400}>
                {decodingContent(headline)}
              </Typo>
              <ProductDetail key="detail" {...props} isNord />
              <Scrolllock key="scroll-lock" />
            </div>
          }
        />
      </div>
    );
  }

  return (
    <Lightbox onCloseRequest={onClose} additionalClass="c-lightbox__locator">
      <div className={`c-lightbox__container ${styles.locatorLightbox} grid-container`}>
        <LightboxHeader handleClose={onClose} title={headline} />
        <div className={styles.detailWrapper}>
          <ProductDetail {...props} />
        </div>
      </div>
    </Lightbox>
  );
}
